import styled, { css } from "styled-components";

interface IContainer {
  height?: string;
}

export const Container = styled.section<IContainer>`
  overflow: auto;
  overflow-x: hidden;
  width: 90vw;
  height: 60vh;
  max-width: 1000px;
  display: flex;
  padding: 1rem;
  align-items: center;
  flex-flow: column nowrap;
  ${(prop) => {
    return (
      !!prop.height &&
      css`
        height: ${prop.height};
      `
    );
  }}
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  ::-webkit-scrollbar {
    width: 0.5rem;
  }
  ::-webkit-scrollbar-track {
    background: #ececec;
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: var(--secondary-color);
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }
`;
